var VariantsStateTypes = {
  Deleted: "Deleted",
  Modified: "Modified",
  Added: "Added",
  Unchanged: "Unchanged"
};

export default VariantsStateTypes;
